import * as S from './style';
import { CardProps } from '../CardContainer/CardContainer';

const CardNotice = ({ children }: CardProps) => <S.CardNoticeContainer>{children}</S.CardNoticeContainer>;

export default CardNotice;
